"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinner = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: ", ";\n  border-top-color: transparent;\n  border-radius: 50%;\n  width: ", ";\n  height: ", ";\n  animation: spin 1s linear infinite;\n\n  @keyframes spin {\n    0% {\n      transform: rotate(0deg);\n    }\n    100% {\n      transform: rotate(360deg);\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledSpinner = _styledComponents.default.div(_templateObject(), function (props) {
  return "".concat(props.thickness, " solid ").concat(props.color || props.theme.colors.actionPrimary300);
}, function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

exports.StyledSpinner = StyledSpinner;